import PropTypes from 'prop-types'
import { cn } from '../../lib/cn'

const variants = {
  default: 'bg-gray-100 text-gray-800',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800'
}

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base'
}

/**
 * Badge component for labels and status indicators
 *
 * @component
 * @example
 * <Badge variant="success" size="md">
 *   Active
 * </Badge>
 */
export default function Badge({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = '',
  ...props
}) {
  const badgeClasses = cn(
    'inline-flex items-center gap-1 font-medium rounded-full',
    variants[variant],
    sizes[size],
    className
  )

  return (
    <span className={badgeClasses} {...props}>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </span>
  )
}

Badge.propTypes = {
  /** Badge content */
  children: PropTypes.node.isRequired,
  /** Visual variant */
  variant: PropTypes.oneOf(['default', 'success', 'warning', 'error', 'info']),
  /** Size of the badge */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Optional icon element */
  icon: PropTypes.node,
  /** Additional CSS classes */
  className: PropTypes.string
}
